import { log } from '.';
import { getUrlPatterns } from '../core';
import { elements } from '../resources';
const { outerListContainer } = elements;

// Get a stripped article id without b or v by default (CAS id)
// if this matches, you know you're on an article page.
// trailing slashes get removed.
// articles always have a ~ followed by a "b" for normal, and "v" for kijkverder articles. and could have a slash behind the url.
// (?<=..) looks for, but does not include the start.
// (?=\/) ensures the pattern stops matching after the optional slash, so no query parameters etc. are sent beyond that point.
// EXAMPLE
// input: https://www.parool.nl/kunst-media/ik-wil-goud-wie-is-joost-klein-de-flamboyante-nederlandse-inzending-voor-het-songfestival~b1c8e389/
// output (default): 1c8e389
// output (prefix = true): ~b1c8e389
export const getArticleID = (
  prefix = false,
  input: string | undefined = undefined
) => {
  const url = input || location.href;
  let match = url.match(/(?<=~[b|v]).*[^/](?=\/)/g);
  if (prefix) {
    match = url.match(/(~).*[^/]/g);
  }
  return match && match[0];
};

export const getContentId = (url: string) => {
  const isKVArticle = url.includes('~v');
  return isKVArticle ? url : getArticleID(false, url);
};

export const isPageBookmarked = (eventList: BookmarkEvent[]) => {
  log('isPageBookmarked', eventList);
  let i = 0;
  let found = false;
  while (i < eventList.length) {
    const { contentId, bookmarked } = eventList[i];
    const articleIDMatches = bookmarked && contentId === getArticleID();
    const urlMatches = bookmarked && contentId === location.href;
    if (articleIDMatches || urlMatches) {
      found = true;
      break;
    }
    i++;
  }
  return found;
};

//Ask the server for patterns if a page can be bookmarked. Mainly article pages for now.
const isBookmarkablePage = async () => {
  if (window.location.href.includes('localhost')) {
    return !!getArticleID();
  }

  const responseBody = await getUrlPatterns();

  const patternMatch = responseBody.isBrandContentPattern.some((pattern, i) => {
    const match = !!location.href.match(pattern);
    log(`Matching pattern ${i + 1}: ${pattern}`);
    log(`pattern ${i + 1} match is ${match}`);
    return match;
  });

  return patternMatch;
};

//if a page has a list element placeholder LIST_ELEMENT_SELECTOR, then it must be a list page.
export const isListPage = () => {
  const out = !!outerListContainer;
  // log('isListPage', out);
  return out;
};

// pagetype
export const getPageType = async () => {
  let pageType: StateType['pageType'] = null;
  if (await isBookmarkablePage()) {
    pageType = 'article';
  }
  if (isListPage()) {
    pageType = 'list';
  }
  return pageType;
};

export const pageWasReloaded = window.performance
  .getEntriesByType('navigation')
  // @ts-expect-error: type IS an existing property, perhaps updating ts will fix it?
  .map((nav) => nav.type)
  .includes('reload');
